<template>
  <table class="palletItems">
    <tr v-for="item in items" v-bind:key="item.id" @click="isItemClickable(item) ? itemClicked(item) : null" :class="isItemClickable(item) ? 'clickable' : ''" :style="isItemClickable(item) ? 'cursor: pointer;' : ''">
      <td style="padding: 0 5px; min-width: 22px;" class="categoryColor">
        <div v-if="item.category && !(item.category.color.secondColor && item.category.color.secondColor !== '')" :style="'width: ' + getColorSize + 'px !important; height: ' + getColorSize + 'px !important; min-width: ' + getColorSize + 'px !important; min-height: ' + getColorSize + 'px !important; background-color: #' + item.category.color.color + '; ' + getColorBorder"></div>
        <div v-if="item.category && item.category.color.secondColor && item.category.color.secondColor !== ''" :style="'width: ' + getColorSize + 'px !important; height: ' + getColorSize + 'px !important; min-width: ' + getColorSize + 'px !important; min-height: ' + getColorSize + 'px !important; background: repeating-linear-gradient(-45deg, #' + item.category.color.color + ', #' + item.category.color.color + ' 3px, #' + item.category.color.secondColor + ' 3px, #' + item.category.color.secondColor + ' 6px); ' + getColorBorder"></div>
      </td>
      <td class="categoryName">
        <div v-if="showImageTag && item.category && item.category.image" style="display: inline; position: relative; top: -2px;">
          <v-icon class="tag">fa-tag</v-icon>
        </div>
        {{ item.category ? (isAdministrator ? item.category.displayLabel : item.category.label) : item.categoryName }}{{ options(item) }}{{ itemAmount(item) }}</td>
    </tr>
  </table>
</template>

<script>

export default {
  name: 'PalletItems',
  props: ['items', 'noPlannedAmount', 'noAmount', 'colorSize', 'colorRadius', 'showImageTag'],
  computed: {
    showAmount: function () {
      return !(this.noAmount === 'true' || (typeof this.noAmount === 'boolean' && this.noAmount === true))
    },
    showPlannedAmount: function () {
      return !(this.noPlannedAmount === 'true')
    },
    isAdministrator: function () {
      return this.$store.getters['session/hasAdministratorRole']
    },
    getColorSize: function () {
      if (this.colorSize) {
        return this.colorSize
      }
      return '10'
    },
    getColorBorder: function () {
      if (this.colorRadius) {
        return 'border-radius: ' + this.colorRadius + 'px; border: 1px solid #bbbbbb; display: inline-block;'
      }
      return 'border: 1px solid #cccccc; display: table-cell;'
    }
  },
  methods: {
    itemAmount: function (item) {
      let amount = ''
      let hasAmount = false
      if (this.showAmount) {
        if (item.amount && item.amount !== 0) {
          amount += ', ' + item.amount + 'pcs'
          hasAmount = true
        }
      }
      if (this.showPlannedAmount && item.plannedAmount) {
        if (hasAmount) {
          amount += ' ('
        } else {
          amount += ', '
        }
        amount += item.plannedAmount + 'pcs'
        if (hasAmount) {
          amount += ')'
        }
      }
      return amount
    },
    options: function (item) {
      let getOptionsAsString = ''
      if (item.options && item.options.length > 0) {
        getOptionsAsString += ' ('
        for (let i = 0; i < item.options.length; i++) {
          if (i > 0) {
            getOptionsAsString += ', '
          }
          getOptionsAsString += item.options[i].name
        }
        getOptionsAsString += ')'
      }
      return getOptionsAsString
    },
    isItemClickable: function (item) {
      return this.showImageTag && item.category && item.category.image
    },
    itemClicked: function (item) {
      this.$emit('itemClicked', item)
    }
  }
}
</script>

<style scoped>
  .palletItems {
    border-collapse: collapse;
  }
  .palletItems tr td {
    padding: 0;
    vertical-align: middle;
  }
  .tag {
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PalletItems.vue